import spinRoute from './spinRoute';

import home from '../views/home/home';
import jump from '../views/home/jump';
import labelRoutes from '../views/_label/js/routes';
import kygMsg from '../js/kygMsg';


//对应home内页面
const homeRoutes = () => [
    {
        path: '/',
        component: home,
        meta: { title: kygMsg(120048, '首页') }
    },
    {
        path: '/jump',
        component: jump,
    },
    {
        path: '/msglist',
        component: () => spinRoute.require(import('../views/msg/msglist.vue')),
        meta: { title: kygMsg(111605, '我的提醒') },
        children: [
            {
                path: '/msg/news',
                component: () => spinRoute.require(import('../views/msg/pages/news.vue')),
                meta: { title: kygMsg(321726, '我的消息') }
            },
            {
                path: '/msg/wftask',
                component: () => spinRoute.require(import('../views/msg/pages/wfTask.vue')),
                meta: { title: kygMsg(321727, '我的审批') }
            },
            {
                path: '/msg/wfHistory',
                component: () => spinRoute.require(import('../views/msg/pages/wf-history.vue')),
                meta: { title: kygMsg(321728, '审批历史') }
            },
        ]
    },
    {
        path: '/myapp',
        redirect: '/allApp',
        component: () => spinRoute.require(import('../views/apps/myapp.vue')),
        meta: { title: kygMsg(321729, '我的应用') },
        children: [
            {
                path: '/allApp',
                component: () => spinRoute.require(import('../views/apps/pages/allApp.vue')),
                meta: { title: kygMsg(311554, '所有') }
            },
            {
                path: '/myfavApp',
                component: () => spinRoute.require(import('../views/apps/pages/myfavApp.vue')),
                meta: { title: kygMsg(321730, '我的收藏') }
            },
        ]
    },
    {
        path: '/arrangeWork',
        component: () => spinRoute.require(import('../views/arrange/arrangeWork.vue')),
        meta: { title: kygMsg(321757, '排班管理') },
    }
];

const flowRoutes = () => [
    {
        path: '/flow',
        redirect: '/allFlow',
        component: () => spinRoute.require(import('../views/flow/flow.vue')),
        meta: { title: kygMsg(321731, '我的申请') },
        children: [
            {
                path: '/allFlow',
                component: () => spinRoute.require(import('../views/flow/pages/allFlow.vue')),
                meta: { title: kygMsg(311554, '所有'), showFav: true }
            },
            {
                path: '/favFlow',
                component: () => spinRoute.require(import('../views/flow/pages/favFlow.vue')),
                meta: { title: kygMsg(321730, '我的收藏') }
            },
            {
                path: '/inFlow',
                component: () => spinRoute.require(import('../views/flow/pages/inFlow.vue')),
                meta: { title: kygMsg(321732, '最近申请') }
            },
        ]
    },
    {
        path: '/wfapprove',
        component: () => spinRoute.require(import('../views/flow/wfapprove.vue')),
        meta: { title: kygMsg(321727, '我的审批'), keepAlive: true },
    },
    {
        path: '/wftask',
        component: () => spinRoute.require(import('../views/msg/pages/wfTask.vue')),
        meta: { title: kygMsg(900583, '待批流程') },
    },
    {
        path: '/wfhistory',
        component: () => spinRoute.require(import('../views/msg/pages/wf-history.vue')),
        meta: { title: kygMsg(321728, '审批历史') },
    },
    {
        path: '/wfnotice',
        component: () => spinRoute.require(import('../views/msg/pages/wfNotice.vue')),
        meta: { title: kygMsg(902055, '告知记录') },
    },
    {
        path: '/wfapply',
        component: () => spinRoute.require(import('../views/flow/pages/allFlow.vue')),
        meta: { title: kygMsg(900482, '发起申请') },
    },
    {
        path: '/wfmine',
        component: () => spinRoute.require(import('../views/flow/wfmine.vue')),
        meta: { title: kygMsg(902069, '申请记录') },
    },
    {
        path: '/wfmine/list',
        component: () => spinRoute.require(import('../views/flow/pages/inFlow.vue')),
        meta: { title: kygMsg(902069, '申请记录') },
    },
    {
        path: '/page',
        component: () => spinRoute.require(import('../views/dynamicPage/dynamicPage.js')),
    },
    {
        path: '/vue',
        component: () => spinRoute.require(import('../views/dynamicPage/vuePage.js')),
    }
]

const tabs = {
    '/': homeRoutes(),
    '/team': [{
        path: '/team',
        component: () => spinRoute.require(import('../views/team/team.vue')),
        meta: { title: kygMsg(120844, '我的团队') }
    }],
    '/flow': flowRoutes(),
    '/time': [{
        path: '/time',
        component: () => spinRoute.require(import('../views/time/time.vue')),
        meta: { title: kygMsg(321733, '时间管理') }
    }],
    '/mine': [{
        path: '/mine',
        component: () => spinRoute.require(import('../views/mine/mine.vue')),
        meta: { title: kygMsg(320707, '我的设置') }
    }],
    '/label/queryContainer': labelRoutes,
    '/label/mineDetailContainer': [
        {
            path: '/label/mineDetailContainer',
            redirect: '/label/mineDetail',
            component: () => spinRoute.require(import('../views/_label/mineDetailContainer.vue')),
            meta: { title: '员工画像' },
            children: [
                {
                    path: '/label/mineDetail',
                    component: () => spinRoute.require(import('../views/_label/detail/mineDetail.vue')),
                    meta: { title: '员工画像' },
                },
                {
                    path: '/label/minesearchAdvance',
                    component: () => spinRoute.require(import('../views/_label/pages/searchAdvance.vue')),
                    meta: { title: '标签管理' },
                },
            ]
        },
    ],
}

//对应下方tabs的页面。返回函数延迟调用，以加载多语言
export default () => (tabs);

